import { Link } from 'react-router-dom';

export default function StatsSection() {
  const stats = [
    { value: '500+', label: '收录品牌', icon: 'ri-building-4-line' },
    { value: '8', label: '品牌品类', icon: 'ri-grid-line' },
    { value: '100万+', label: '月活用户', icon: 'ri-user-star-line' },
    { value: '98%', label: '用户好评', icon: 'ri-thumb-up-line' },
  ];

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-3">
            国产第一页 · 平台数据
          </h2>
          <p className="text-sm text-background-300 max-w-lg mx-auto">
            我们用数据见证国货的崛起力量，为数百万用户提供最专业的国产品牌导航服务
          </p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-background-900/50 rounded-lg p-6 md:p-8 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500/20">
                <i className={`${stat.icon} text-primary-400 text-xl`}></i>
              </div>
              <div className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-2">
                {stat.value}
              </div>
              <div className="text-sm text-background-300">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}